import React, { useState, useEffect } from 'react';
import { productsAPI, settingsAPI } from '../services/api';
import ProductCard from '../components/ProductCard';
import Loading from '../components/Loading';

const HomePage = () => {
  const [products, setProducts] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [productsRes, settingsRes] = await Promise.all([
          productsAPI.getAll(),
          settingsAPI.getPublic(),
        ]);
        setProducts(productsRes.data.products || []);
        setSettings(settingsRes.data.settings || null);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <Loading message="Loading fresh pickles..." />;

  const orderWindowOpen = settings?.orderWindowOpen !== false;

  return (
    <div>
      {/* Hero Banner */}
      <section className="hero">
        <h1>{settings?.bannerMessage || 'Fresh Homemade Pickles – Made Just for You!'}</h1>
        <p>
          Authentic Gujarati pickles, handcrafted with love and traditional recipes passed down through generations.
        </p>
        {!orderWindowOpen && (
          <div className="order-closed-banner">
            🔒 Order window closed. We are now preparing your fresh pickles! 🌶️
          </div>
        )}
        {orderWindowOpen && settings?.orderWindowMessage && (
          <div className="order-closed-banner" style={{ background: 'rgba(46, 125, 50, 0.55)', display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center' }}>
            📢 {settings.orderWindowMessage}
          </div>
        )}
      </section>

      {/* Products Grid */}
      <div className="container">
        <div style={{ paddingTop: 36, marginBottom: 4 }}>
          <h2 style={{ marginBottom: 4, color: 'var(--text-heading)' }}>🫙 Our Pickle Collection</h2>
          <p style={{ color: 'var(--text-light)', fontSize: '0.92rem', marginBottom: 0 }}>
            Select your favourites and choose quantity in kg
          </p>
        </div>
        <div className="products-grid">
          {products.map((product) => (
            <ProductCard
              key={product._id}
              product={product}
              orderWindowOpen={orderWindowOpen}
            />
          ))}
        </div>

        {products.length === 0 && (
          <div className="empty-state">
            <div className="emoji">🫙</div>
            <h3>No products available right now</h3>
            <p>Check back soon for our fresh pickle collection!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomePage;
